window.Auth = {
	checkAuthAfterLogin: function () {
		$.get('/login/social/check', function (data) {
			if (data.error) {

			} else {
				location.href = data.redirect_to;
			}
		});
	},
};

$(document).ready(function () {
	let socialAuthTm, socialAuthWindow;
	let $formReg = $("form#type-reg");
	let $formForgot = $("form#type-forgot");
	let $formLoginEmail = $("form#login-email");
	let $formLoginPhoneCode = $("form#login-phone-code");

	$('.social-auth').click(function () {
		let link = $(this).attr('href');

		socialAuthWindow = popupwindow(link, 'Авторизация', 600, 600);
		socialAuthTm = setInterval(function () {
			if (socialAuthWindow.closed) {
				clearInterval(socialAuthTm);
				Auth.checkAuthAfterLogin();
			}
		}, 100);
		return false;
	});

	const $auth = $('.account-auth--card');
	$auth.find('[data-email]').on('change', function () {
		let $self = $(this),
			value = $self.val(),
			$auth = $('.account-auth--card'),
			$email = $auth.find('#type-email'),
			$phone = $auth.find('#type-phone'),
			$typeEmailPhone = $auth.find('.type-email-phone');

		$email.hide();
		$phone.hide();
		$auth.find('#type-no-account').hide();

		if (!validateEmail(value) && value.length && isNumeric(value)) {
			$typeEmailPhone.addClass('phone');
			$typeEmailPhone.find('[data-phone]').val(value);
			$typeEmailPhone.find('[data-email]').val('');
			$formLoginPhoneCode.find('[name=phone]').val($auth.find('.type-email-phone [name=user_phone]').val());

			hideAlert($formLoginPhoneCode);

			let params = {phone: value, _token: App.csrf};

			$.post('/login/request_code', params, function (data) {
				if (data.error) {
					getAlert($("#type-fields-email-phone"), data.error, data.msg);
				} else {
					$auth.find('#type-fields-email-phone').hide();
					$phone.show();
					$phone.find('[name=code]').focus();
					$auth.find('#type-link-reg').hide();

					setTimeout(function () {
						$formLoginPhoneCode.find('.send-sms').show();
					}, 1000 * 30);
				}
			});
		} else if (validateEmail(value)) {
			$formReg.find('[name=email]').val(value);
			$formForgot.find('[name=email]').val(value);
			let params = {email: value, _token: App.csrf};

			$.post('/login/check_account_exists', params, function (data) {
				if (!data.error) {
					// after ajax query
					$email.show();
					$auth.find('#type-link-reg').hide();
				} else {
					// в случае ошибки выводи это
					$auth.find('#type-no-account').show();
				}
			});
		} else {
			$auth.find('#type-link-reg').show();
		}

		return false;
	});

	$auth.find('[data-phone]').on('keyup', function () {
		let $self = $(this),
			value = $self.val(),
			$auth = $('.account-auth--card'),
			$typeEmailPhone = $auth.find('.type-email-phone'),
			$login = $auth.find('#type-login');

		if (!value.length) {
			$typeEmailPhone.removeClass('phone');
			$typeEmailPhone.find('[data-phone]').val('');
			$typeEmailPhone.find('[data-email]').val('');

			$login.hide();
		}

		return false;
	});

	$formReg.submit(function () {
		let $form = $(this),
			route = $(this).attr('action'),
			params = $(this).serializeArray();

		hideAlert($form);

		let $btn = $formReg.find('button[type=submit]');
		$btn.data('previous-text', $btn.text()).text($btn.data('loading-text')).attr('disabled', 'disabled');

		$.post(route, params, function (data) {
			if (data.error) {
				getAlert($form, data.error, data.msg);
				$btn.text($btn.data('previous-text')).removeAttr('disabled');
			} else if (data.redirect_to) {
				location.href = data.redirect_to;
			}
		});

		return false;
	});

	$formLoginEmail.submit(function () {
		$(this).find('[name=email]').val($auth.find('.type-email-phone [name=user_email]').val());

		let $form = $(this),
			route = $(this).attr('action'),
			params = $(this).serializeArray();

		hideAlert($form);

		let $btn = $formLoginEmail.find('button[type=submit]');
		$btn.data('previous-text', $btn.text()).text($btn.data('loading-text')).attr('disabled', 'disabled');

		$.post(route, params, function (data) {
			if (data.error) {
				$btn.text($btn.data('previous-text')).removeAttr('disabled');
				getAlert($form, data.error, data.msg);
			} else if (data.redirect_to) {
				location.href = data.redirect_to;
			}
		});

		return false;
	});

	$formLoginPhoneCode.submit(function () {
		let $form = $(this),
			route = $(this).attr('action'),
			params = $(this).serializeArray();

		hideAlert($form);

		let $btn = $formLoginPhoneCode.find('button[type=submit]');
		$btn.data('previous-text', $btn.text()).text($btn.data('loading-text')).attr('disabled', 'disabled');

		$.post(route, params, function (data) {
			if (data.error) {
				$btn.text($btn.data('previous-text')).removeAttr('disabled');
				getAlert($form, data.error, data.msg);
			} else if (data.redirect_to) {
				location.href = data.redirect_to;
			}
		});

		return false;
	});

	$formLoginPhoneCode.find('.btn-login-phone-code-get-sms').click(function () {
		let phone = $formLoginPhoneCode.find('[name=phone]').val();
		let params = {phone: phone, _token: App.csrf, sms: true};
		$formLoginPhoneCode.find('.send-sms').hide();

		hideAlert($formLoginPhoneCode);

		$.post('/login/request_code', params, function (data) {
			if (data.error) {
				getAlert($formLoginPhoneCode, data.error, data.msg);
			} else {
				$formLoginPhoneCode.find('.msg-code').text('Вам отправлено СМС с кодом для входа - введите его в поле ниже.');
			}
		});

		return false;
	});

	$formForgot.submit(function () {
		let $form = $(this),
			route = $(this).attr('action'),
			params = $(this).serializeArray();

		let $btn = $formForgot.find('button[type=submit]');
		$btn.data('previous-text', $btn.text()).text($btn.data('loading-text')).attr('disabled', 'disabled');

		hideAlert($form);

		$.post(route, params, function (data) {
			$btn.text($btn.data('previous-text')).removeAttr('disabled');

			getAlert($form, data.error, data.msg);
		});

		return false;
	});

	$(".btn-get-reg").click(function () {
		let $auth = $('.account-auth--card');

		$auth.find('#type-fields-email-phone').hide();
		$auth.find('#type-link-reg').hide();
		$auth.find('#type-reg').show();
		$auth.find('#type-no-account').hide();

		return false;
	});

	$(".btn-get-login").click(function () {
		let $auth = $('.account-auth--card');

		$auth.find('#type-fields-email-phone [data-email]').val('');
		$auth.find('#type-fields-email-phone [data-phone]').val('');
		$auth.find('#type-fields-email-phone').show();
		$auth.find('#type-link-reg').show();
		$auth.find('#type-reg').hide();
		$auth.find('#type-forgot').hide();

		return false;
	});

	$('.bth-get-forgot').click(function () {
		let $auth = $('.account-auth--card');

		$auth.find('#type-email').hide();
		$auth.find('#type-fields-email-phone').hide();
		$auth.find('#type-forgot').show();

		return false;
	});
});

/**
 * @param email
 * @returns {RegExpMatchArray}
 */
function validateEmail(email) {
	return String(email).toLowerCase().match(
		/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
	);
}

/**
 * @param n
 * @returns {boolean}
 */
function isNumeric(n) {
	return !isNaN(parseFloat(n)) && isFinite(n);
}

/**
 * @param container
 * @param msg
 * @param slide
 */
function hideAlert(container) {
	let $request = container.find('.request-area');
	$request.hide();
}

function getAlert(container, error, msg = null) {
	let $request = container.find('.request-area'),
		$alert = $request.find('.request-alert');

	$alert.removeClass('text-success').removeClass('text-danger');

	if (error) {
		$alert.addClass('text-danger');
	} else {
		$alert.addClass('text-success');
	}

	$alert.html(msg)
	$request.show();

	return false;
}